import React, { useId, useRef } from "react";

import { EMAIL_RETENTION_OPTIONS } from "../../config/emailRetentionOptions";

/** Custom trigger plus native popover menu for retention (not a native select). */
export function EmailRetentionPopoverSelect({
  value,
  onChange,
  disabled = false,
  sectionHeading = false,
  hideLabel = false,
}) {
  const reactId = useId().replace(/:/g, "");
  const popoverId = `email-retention-popover-${reactId}`;
  const popoverRef = useRef(null);
  const selected = EMAIL_RETENTION_OPTIONS.find((o) => o.value === value) || EMAIL_RETENTION_OPTIONS[0];

  const pick = (next) => {
    onChange(next);
    popoverRef.current?.hidePopover?.();
  };

  return (
    <div className="max-w-md">
      {hideLabel ? null : (
        <p
          className={
            sectionHeading
              ? "font-display font-bold text-lg text-theme-on-background mb-2"
              : "font-mono text-[10px] uppercase tracking-[0.08em] text-theme-dim mb-2"
          }
        >
          Message retention
        </p>
      )}
      <button
        type="button"
        popoverTarget={popoverId}
        disabled={disabled}
        className={`flex w-full items-center justify-between gap-3 rounded-lg border border-theme-border bg-theme-surface px-4 py-3 text-left font-mono text-[12px] text-theme-text transition ${
          disabled ? "cursor-not-allowed opacity-60" : "hover:border-theme-border-bright"
        }`}
      >
        <span className="truncate">{selected.title}</span>
        <span className="shrink-0 text-theme-dim" aria-hidden>
          ▾
        </span>
      </button>
      <div
        ref={popoverRef}
        id={popoverId}
        popover="auto"
        className="w-[min(100vw-2rem,22rem)] rounded-lg border border-theme-border bg-theme-panel p-1 shadow-lg"
      >
        {EMAIL_RETENTION_OPTIONS.map((opt) => {
          const isOn = value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => pick(opt.value)}
              disabled={disabled}
              className={`flex w-full flex-col items-stretch gap-0.5 rounded-md px-3 py-2.5 text-left transition disabled:opacity-50 ${
                isOn ? "bg-theme-accent-muted" : "hover:bg-theme-main"
              }`}
            >
              <span className="font-display text-sm font-semibold text-theme-on-background">{opt.title}</span>
              <span className="font-mono text-[10px] leading-snug text-theme-muted">{opt.summary}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
